export default __webpack_public_path__ + "static/G-SYNC-951413fa8abeff506180732664d75d54.webp";